export const nav = [
  { title: "SPORTS" },
  { title: "FITNESS" },
  { title: "SHOES" },
  { title: "CLOTHING" },
  { title: "ACCESSORIES" },
  { title: "LEISURE SPORTS" },
  { title: "FANGEAR" },
  { title: "BRANDS" },
];
export const navmain = [
  { title: "Volley balls", to: "/Volleyballs" },
  { title: "Abtrainers", to: "/Abtrainers" },
  { title: "Accessories", to: "/Accessories" },
  { title: "Agility", to: "/Agility" },
  { title: "Badminton", to: "/Badminton" },
  { title: "Balance board", to: "/Balanceboard" },
  { title: "Balls", to: "/Balls" },
  { title: "Basket ball", to: "/Basketball" },
  { title: "Bat case", to: "/Batcase" },
  { title: "Bats", to: "/Bats" },
  { title: "Billiards", to: "/Billiards" },
  { title: "Caps", to: "/Caps" },
  { title: "Cycles", to: "/Cycles" },
  { title: "Darts & Darts board", to: "/Dartsdartsboard" },
  { title: "Equipments", to: "/Equipments" },
  { title: "Fitness mats", to: "/Fitnessmats" },
  { title: "Footballs", to: "/Footballs" },
  { title: "Football shoes", to: "/Footballshoes" },
  { title: "Goalie gloves", to: "/Goaliegloves" },
  { title: "Goggles", to: "/Goggles" },
  { title: "Grips", to: "/Grips" },
  { title: "Hand grips", to: "/Handgrips" },
  { title: "Kitbags", to: "/Kitbags" },
  { title: "Rubbers", to: "/Rubbers" },
  { title: "Shin gaurds", to: "/Shingaurds" },
  { title: "Shoes", to: "/Shoes" },
  { title: "Shuttle cock", to: "/Shuttlecock" },
  { title: "Skipping ropes", to: "/Skippingropes" },
  { title: "Stepper", to: "/Stepper" },
  { title: "Strings", to: "/Strings" },
  { title: "Swimwear", to: "/Swimwear" },
  { title: "Tables", to: "/Tables" },
  { title: "Tennis shoes", to: "/Tennisshoes" },
];
